module.exports = __webpack_public_path__ + "img/NL9312141.96449ae8.png";